import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBuilding, faIndustry, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ParticleNetwork from '../components/ParticleNetwork';
import '../styles/GroupCompaniesPage.css';

const GroupCompaniesPage = () => {
  const { t } = useTranslation();

  const companies = [
    {
      name: 'KUS GRUP',
      logo: '/images/1-1.png',
      description: t('home.company_kus'),
      icon: faBuilding,
      link: '/products',
      linkType: 'internal',
      sectors: ['Alçıpan Profilleri', 'Bağlantı Ekipmanları', 'Yapı Çözümleri']
    },
    {
      name: 'Marmara Teknik Makine',
      logo: '/images/3-1.png',
      description: t('home.company_marmara'),
      icon: faIndustry,
      link: 'https://marmarateknikmakine.com.tr/',
      linkType: 'external',
      sectors: ['Konveyör Sistemleri', 'Endüstriyel Makine', 'Otomasyon']
    },
    {
      name: 'Gebze Palet',
      logo: '/images/2-1.png',
      description: t('home.company_gebze'),
      icon: faLayerGroup,
      link: 'https://gebzepalet.com.tr/',
      linkType: 'external',
      sectors: ['Ahşap Palet', 'Ambalaj Çözümleri', 'Lojistik Destek']
    }
  ];

  return (
    <div className="group-companies-page">
      <section className="group-hero">
        <ParticleNetwork />
        <div className="container">
          <motion.div
            className="hero-centered-content"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="breadcrumbs">
              <Link to="/">{t('nav.home')}</Link>
              <span className="separator">/</span>
              <span className="current">{t('nav.group_companies')}</span>
            </div>
            <h1 className="hero-title">{t('nav.group_companies')}</h1>
            <div className="hero-accent-line"></div>
          </motion.div>
        </div>
      </section>

      <section className="group-companies-list">
        <div className="container">
          <div className="group-intro">
            <h2>Tek çatı altında güçlü üretim ve tedarik ağı</h2>
            <p>
              Kuş Grup; yapı ürünleri, endüstriyel makine ve ambalaj alanlarında
              uzmanlaşan grup firmalarıyla projelere uçtan uca çözüm sunar.
            </p>
          </div>

          <div className="group-company-grid">
            {companies.map((company, index) => (
              <motion.article
                className="group-company-card"
                key={company.name}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.12 }}
              >
                <div className="group-company-logo">
                  <img src={company.logo} alt={`${company.name} Logo`} />
                </div>
                <div className="group-company-body">
                  <div className="company-title-row">
                    <span className="company-icon">
                      <FontAwesomeIcon icon={company.icon} />
                    </span>
                    <h3>{company.name}</h3>
                  </div>
                  <p>{company.description}</p>
                  <ul>
                    {company.sectors.map((sector) => (
                      <li key={sector}>{sector}</li>
                    ))}
                  </ul>
                  {company.linkType === 'internal' ? (
                    <Link className="company-action" to={company.link}>
                      <span>Detayları Gör</span>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                  ) : (
                    <a className="company-action" href={company.link} target="_blank" rel="noopener noreferrer">
                      <span>Web Sitesine Git</span>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </a>
                  )}
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GroupCompaniesPage;
